import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import EditIcon from "../../../../Assets/OptionsModel/edit.svg";
import DeleteIcon from "../../../../Assets/OptionsModel/Delete.svg";
import ViewIcon from "../../../../Assets/OptionsModel/View.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { setListModal, setSelectedKebabItem } from '../../../../Features/couponsSlice';
import Reactivate from "../../../../Assets/Reactive.svg";
import Expired from "../../../../Assets/OptionsModel/ticket_expired.svg";

function KebabMenu({ boxRef, coupon, status }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [visible, setVisible] = useState(false);

    const couponKebabOpen = useSelector((state) => state.coupons.couponKebab.kebabOpen);

    const handleViewCoupon = () => {
        navigate(`${location.pathname}/coupon/${coupon.id}`);
    }

    const handleEdit = () => {
        let couponTypeRoute;

        switch (coupon.typeCoupon) {
            case 'PERCENTAGE_DISCOUNTS':
                couponTypeRoute = 'percentage-discounts';
                break;
            case 'FIXED_DISCOUNTS':
                couponTypeRoute = 'fixed-discounts';
                break;
            case 'BUYX_GETX':
                couponTypeRoute = 'buy-x-get-x';
                break;
            default:
                couponTypeRoute = '';
        }

        navigate(`${location.pathname}/edit-coupon/${couponTypeRoute}/${coupon.id}`);
    }

    const handleDelete = (e) => {
        e.stopPropagation();
        dispatch(setSelectedKebabItem(coupon));
        dispatch(setListModal('delete-confirm'));
    }

    const handleMarkAsExpired = (e) => {
        e.stopPropagation();
        dispatch(setSelectedKebabItem(coupon));
        dispatch(setListModal('expire-confirm'));
    }

    const handleReactivateCoupon = (e) => {
        e.stopPropagation();
        dispatch(setSelectedKebabItem(coupon));
        dispatch(setListModal('reactivate-coupon'));
    }

    useEffect(() => {
        if(couponKebabOpen) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [couponKebabOpen]);

    return (
        <div ref={boxRef} className={`${visible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all duration-150 ease-in-out bg-[#FFFFFF] absolute z-10 w-40 top-6 right-12 flex flex-col gap-0 shadow-[0px_0px_12px_0px_#0000003D] rounded-md overflow-hidden`}>
            <button onClick={handleViewCoupon} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={ViewIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>View</p>
            </button>

            <button onClick={handleEdit} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={EditIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>Edit</p>
            </button>

            {/* <button onClick={handleDelete} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={DeleteIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>Delete</p>
            </button> */}

            {
                status.name === 'Active' && 
                <button onClick={handleMarkAsExpired} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                    <div className="size-[18px] flex items-center justify-center">
                        <img src={Expired} alt="" />
                    </div>

                    <p className='font-medium text-[14px] leading-5 text-[#121212]'>Mark as Expired</p>
                </button>
            }

            {
                status.name === 'Expired' && 
                <button onClick={handleReactivateCoupon} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                    <div className="size-[18px] flex items-center justify-center">
                        <img src={Reactivate} alt="" />
                    </div>

                    <p className='font-medium text-[14px] leading-5 text-[#121212]'>Reactivate</p>
                </button>
            }
        </div>
    );
}

export default KebabMenu;
